import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  Fragment,
  useMemo,
} from "react";
import { Box, useTheme } from "@mui/material";
import { MapContainer, TileLayer, useMap, useMapEvents } from "react-leaflet";
import simplify from "simplify-js";
import ToolBarMaps from "../../../../../componentes/easyMaps/toolbarMaps";
import L from "leaflet";
import "../../../../../componentes/leaflet-migrations";
import "../../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import "leaflet-routing-machine";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuMaps from "../../../../../componentes/easyMaps/menuMaps";
import RightBarEasyMaps from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import CreationSliderBarEasyMaps from "../../../../../componentes/easyMaps/creationSidebarEasymaps";
import EnlaceSideBarEasyMaps from "../../../../../componentes/easyMaps/enlaceSidebarEasyMaps";
import TitleBar from "../../../../../componentes/easyMaps/titleBar";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import PointIcon from "./pointIcon";
//import * as turf from "@turf/turf";
import ElementMenu from "../../../../../componentes/easyMaps/elementMenu";
import ContextMenu from "../../../../../componentes/easyMaps/contextMenu";
import AlertModal from "../../../../../componentes/alertModal";
import { PolylineSimple } from "./polyLine";
import { useOutletContext } from "react-router-dom";
import LayerBar from "../../../../../componentes/easyMaps/layerBar";
import RulerComponent from "../../../../../componentes/easyMaps/rulerPoints";
import { useMapa } from "../../../../../contexts/mapaContext";
import { useMapActions } from "../../../../../contexts/mapActionsContext";
import FilterGeneric from "../../../../../componentes/easyMaps/filterGeneric";
import {
  buildPolygon,
  pointInAnyPolygon,
} from "../../../../../utils/pointInPolygon";
import PixiOverlay from "./pixiOverlayIcons";
import TextBoxLayer from "./components/textBoxLayer";
import PolygonLayer from "./components/polygonLayer";
import useTextures from "./hooks/useTextures";
import { scales } from "./components/drawLine";
import ModalHistoryItem from "../../../../../componentes/easyMaps/historyItemModal";
import { ModalEditMassPolygon } from "../../../../../componentes/easyMaps/modalEditMassPolygon";
import { areaElementToRow } from "../../../../../componentes/easyMaps/modalEditMassPolygon/mappers";

dayjs.extend(utc);
dayjs.extend(timezone);

const LeafletMapa = forwardRef((props, ref) => {
  const {
    title,
    setFullScreem,
    fullScreem,
    socketCliente,
    iconsElements = [],
    setIconsElement,
    produtos = [],
    api,
    mapas = [],
    setMapas = () => {},
    boundsCoordinates,
    centerCoordinates = [-10, -48],
    latLngZoomFromUrl,
    onImportComplete,
    collapse,
  } = props;

  const {
    mapId,
    elements,
    setElements,
    connections,
    setConnections,
    elementSelected,
    setElementSelected,
    connectionSelected,
    setConnectionSelected,
    editMode,
    setEditMode,
    checkChanges,
    setCheckChanges,
    setSnackbar,
    updateDataElementSocket,
    configElementDataMap,
    configurationMap,
    connectionsDataMap,
    connectionsDataMapPercentTraffic,
    connectionsDataMapPercentPower,
    rulerMode,
    setRulerMode,
    startMapRef,
    hostGroups,
    hostsDataMap,
  } = useMapa();
  const theme = useTheme();

  const [lockMode, setLockMode] = useState(false);
  const [showLabel, setShowLabel] = useState(false);
  const [zoomIcons, setZoomIcons] = useState(5);
  const [contextMenu, setContextMenu] = useState(null);
  const [elementsConnected, setElementsConnected] = useState([]);
  const [openRightBar, setOpenRightBar] = useState(false);
  const [loadRouting, setLoadRouting] = useState(false);
  const [contextMenuFlow, setContextMenuFlow] = useState(null);
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [openConnection, setOpenConnection] = useState(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  const [rulerPoint, setRulerPoint] = useState([]);
  const [hideArea, setHideArea] = useState(false);

  const mapRef = useRef(null);
  const didSetInitialZoom = useRef(false);
  const creationRef = useRef();
  const enlaceBarRef = useRef();
  const checkChangesRef = useRef();
  const { config, configLayer, setConfigLayer } = useOutletContext();
  const { setMenuConfig } = useMapActions();
  const [pointsClone, setPointsClone] = useState([]);
  const [menuCreation, setMenuCreation] = useState(false);
  const [disableNodes, setDisableNodes] = useState(false);
  const [disableLinesZoom, setDisableLinesZoom] = useState(false);
  const moveTimeout = useRef();
  //lines emakers formated for pixi overlay
  const [markers, setMarkers] = useState([]);
  const [connectionsLine, setConnectionsLine] = useState([]);
  const [radiusNodePixi, setRadiusNodePixi] = useState(null);
  const [openEnlaceBar, setOpenEnlaceBar] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const typeElements = ["Host", "Mapa", "POP", "Texto"];
  const [connectionLocal, setConnectionLocal] = useState(null);
  const [hostParamModal, setHostParamModal] = useState("");
  const [hostGroupsFilter, setHostGroupsFilter] = useState([]);
  // Mass edit poligns
  const [openMassEditPolygon, setOpenMassEditPolygon] = useState(false);
  // Filters
  const [selectedFilters, setSelectedFilters] = useState({});
  // pega os elementos, conexões e alertas do Map
  const elementsFromMap = useMemo(() => [...elements?.values()], [elements]);
  const polygons = useMemo(
    () => elementsFromMap.filter((e) => e.tipo === 4).map(areaElementToRow),
    [elementsFromMap],
  );

  const connectionsFromMap = useMemo(
    () => [...connections?.values()],
    [connections],
  );

  const handleMassPolygonComplete = useCallback(async () => {
    setCheckChanges(false);
    setElementSelected(null);
    await onImportComplete?.();
  }, [onImportComplete, setCheckChanges, setElementSelected]);

  const filtersOptions = useMemo(() => {
    const result = {};
    for (const element of elementsFromMap) {
      if (element.tipo === 4) {
        if (!result["Área"]) {
          result["Área"] = [];
        }
        result["Área"].push(element.titulo);
      }
    }
    return result;
  }, [elementsFromMap]);

  useEffect(() => {
    checkChangesRef.current = checkChanges;
  }, [checkChanges]);

  useEffect(() => {
    setMenuConfig({
      mapId,
      title,
      produtos,
      setSnackbar,
      onImportComplete,
      exportImport: true,
      isPing: false,
      updateDataElementSocket,
    });
    return () => setMenuConfig(null);
  }, [mapId, title, produtos]);

  const styles = {
    paperContainer: {
      padding: "16px ",
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "100%",
      borderRadius: 3,
      mt: 5.5,
    },
    body: {
      width: "100%",
      height: "100%",
      // minWidth: "610px",
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      left: "0px",
      top: "0px",
      //zIndex: 0,
      overflow: "hidden",
    },

    mapInfoStack: {
      padding: "12px 16px",
      width: "250px",
    },
    mapInfoDataStack: {
      padding: "12px 16px",
      width: "120px",
    },
    mapInfoTitle: {
      fontSize: "0.75rem",
      lineHeight: 1.25,
      fontWeight: 600,
      letterSpacing: "0.033em",
      color: "primary.main",
    },
    mapInfoText: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 400,
      textTransform: "capitalize",
    },
    fontPopup: {
      margin: "0px",
      fontSize: "10px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
      width: "100%",
      textAlign: "center",
      marginBottom: "10px",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limite de 2 linhas
      WebkitBoxOrient: "vertical",
    },
  };

  const points = useMemo(() => {
    if (connectionSelected) {
      let nodeStart = elements?.get(connectionSelected.referenceId);
      let nodeEnd = elements?.get(connectionSelected.destinationId);

      let nodeStartPosition = {
        lat: parseFloat(
          nodeStart?.elementConfig?.config?.coordenadas?.lat || 0,
        ),
        long: parseFloat(
          nodeStart?.elementConfig?.config?.coordenadas?.long || 0,
        ),
        active: false,
      };
      let nodeEndPosition = {
        lat: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.lat || 0),
        long: parseFloat(
          nodeEnd?.elementConfig?.config?.coordenadas?.long || 0,
        ),
        active: false,
      };

      let points = [
        nodeStartPosition,
        ...(connectionSelected.positionHandlers ?? []).map((a) => ({
          lat: a.y || 0,
          long: a.x || 0,
          active: false,
        })),
        nodeEndPosition,
      ];

      return points;
    } else {
      return [];
    }
  }, [connectionSelected]);

  function resolveThemePath(theme, path) {
    return path?.split(".").reduce((obj, key) => obj?.[key], theme);
  }

  useEffect(() => {
    const mks = elementsFromMap
      .filter((el) => el.tipo !== 3 && el.tipo !== 4)
      .map((element) => {
        const configElement = configElementDataMap.get(element.id);
        const iconExists = iconsElements?.some(
          (icon) => icon.id === element.img,
        );
        return {
          ...element,
          position: [
            parseFloat(element?.elementConfig?.config?.coordenadas?.lat),
            parseFloat(element?.elementConfig?.config?.coordenadas?.long),
          ],
          iconId: iconExists
            ? element.img
            : iconsElements?.find(
                (icon) =>
                  icon.nome ==
                  (element.tipo === 0
                    ? "_roteador"
                    : element.tipo === 1
                      ? "_mapa"
                      : "_pop"),
              )?.id, // caso não tenha, recebe o id com base no tipo de elemento
          baseIcon: "marker_circle",
          tint: configElement?.isDown
            ? theme.palette.color?.zabbixSeverty?.disaster
            : resolveThemePath(theme, configElement?.border) ||
              theme.palette.color?.zabbixSeverty.selected,
          severity: configElement?.severity,
          label: element.titulo ?? element.id, // nbsp p/ não quebrar layout
        };
      });
    setMarkers(mks);
  }, [elementsFromMap, iconsElements, configElementDataMap]);

  useEffect(() => {
    const connections = connectionsFromMap.map((conn) => {
      const positions = formatPoints(conn);
      return {
        id: conn.id,
        variant: configLayer?.[mapId] || "trafego",
        referenceId: conn.referenceId,
        destinationId: conn.destinationId,
        config: {
          animation: conn.config.animation,
          type: conn.config.type,
          capacidade: conn.config.capacidade,
          interfaceName: conn.config.interfaceName,
        },
        positions,
      };
    });
    setConnectionsLine(connections);
  }, [connectionsFromMap, elementSelected?.elementConfig?.config?.coordenadas]);

  const filteredData = useMemo(() => {
    if (!configurationMap || !configLayer || editMode) {
      return { markers: markers, enlaces: connectionsLine };
    }
    const isPotencia = configLayer?.[mapId] === "potencia";
    const filtros =
      configurationMap?.configuracoes?.[
        isPotencia ? "camadaPotencia" : "camadaTrafego"
      ]?.filtros;
    if (!filtros || filtros.length === 0) {
      return { markers: markers, enlaces: connectionsLine };
    }

    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    // Gera um Set com todos os IDs de conexões filtradas (evita includes O(n))
    const enlacesSelected = new Set(
      filtros?.flatMap((label) => dataMap.get(label) || []),
    );
    //filtras as conexões com base nos filtros
    const enlacesFiltered = connectionsLine.filter((conn) =>
      enlacesSelected.has(conn.id),
    );

    // Filtra conexões relevantes e extrai IDs únicos de markers
    const markersSelectedId = new Set(
      connectionsLine?.flatMap((conn) =>
        enlacesSelected.has(conn.id)
          ? [conn.destinationId, conn.referenceId]
          : [],
      ),
    );
    // Retorna apenas markers com ID presente
    const filtered = markers.filter((m) => markersSelectedId.has(m.id));

    return { markers: filtered, enlaces: enlacesFiltered };
  }, [
    configurationMap,
    configLayer,
    connectionsLine,
    mapId,
    markers,
    editMode,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
  ]);

  // grupos de host presentes nos markers já filtrados (alimenta o dropdown)
  const visibleHostGroups = useMemo(() => {
    const groups = new Set();
    filteredData.markers.forEach((marker) => {
      const hosts = hostsDataMap?.get(marker.id) || [];
      hosts.forEach((host) => {
        (host.groups || []).forEach((g) => groups.add(g));
      });
    });
    return Array.from(groups);
  }, [filteredData, hostsDataMap]);

  // aplica o filtro de grupos por cima; enlace só aparece se ambas as pontas continuarem visíveis
  const finalData = useMemo(() => {
    if (hostGroupsFilter.length === 0) return filteredData;

    const groupMarkers = filteredData.markers.filter((m) => {
      const hosts = hostsDataMap?.get(m.id) || [];
      return hosts.some((host) =>
        (host.groups || []).some((g) => hostGroupsFilter.includes(g)),
      );
    });

    const visibleIds = new Set(groupMarkers.map((m) => m.id));
    const groupEnlaces = filteredData.enlaces.filter(
      (conn) =>
        visibleIds.has(conn.referenceId) && visibleIds.has(conn.destinationId),
    );

    return { markers: groupMarkers, enlaces: groupEnlaces };
  }, [filteredData, hostGroupsFilter, hostsDataMap]);

  const selectedAreaPolygons = useMemo(() => {
    const names = selectedFilters?.["Área"];
    if (!Array.isArray(names) || names.length === 0) return null;
    const set = new Set(names);
    return elementsFromMap
      .filter((el) => el.tipo === 4 && set.has(el.titulo))
      .map((el) => buildPolygon(el?.elementConfig?.config?.polygon?.points))
      .filter(Boolean);
  }, [selectedFilters, elementsFromMap]);

  const insideElementIds = useMemo(() => {
    if (!selectedAreaPolygons || selectedAreaPolygons.length === 0) return null;
    const ids = new Set();
    for (const el of elementsFromMap) {
      if (el.tipo === 4) continue;
      const c = el?.elementConfig?.config?.coordenadas;
      if (
        pointInAnyPolygon(
          parseFloat(c?.lat),
          parseFloat(c?.long),
          selectedAreaPolygons,
        )
      ) {
        ids.add(el.id ?? el.tempId);
      }
    }
    return ids;
  }, [selectedAreaPolygons, elementsFromMap]);

  const rangeCounts = useMemo(() => {
    const isPotencia = configLayer?.[mapId] === "potencia";
    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    if (!dataMap || connectionsLine.length === 0) return {};

    const visibleIds = new Set(connectionsLine.map((c) => c.id));
    const counts = {};

    for (const [label, ids] of dataMap.entries()) {
      let count = 0;
      for (const id of ids) {
        if (visibleIds.has(id)) count++;
      }
      counts[label] = count;
    }
    return counts;
  }, [
    configLayer,
    mapId,
    connectionsLine,
    connectionsDataMapPercentTraffic,
    connectionsDataMapPercentPower,
  ]);

  useImperativeHandle(ref, () => ({
    focusZoomExt(id) {
      setElementSelected(elements?.get(id) ?? null);
      focusZoom(id);
    },
  }));

  useEffect(() => {
    if (!rulerMode) return;

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "z") {
        e.preventDefault();
        removeLastEl();
      }
    };

    const handleMouseClick = (e) => {
      if (e.button === 2) {
        e.preventDefault();
        removeLastEl();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleMouseClick);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleMouseClick);
    };
  }, [rulerMode]);

  useEffect(() => {
    if (pointsClone) {
      setPointsClone([...points]);
    } else {
      setPointsClone([]);
    }
  }, [points]);

  useEffect(() => {
    if (!elementSelected?.id) setElementSelected(null);
    if (editMode == false) {
      setElementSelected((data) => elements?.get(data?.id) || null);
    }
    setConnectionSelected(null);
    setElementsConnected(null);
  }, [editMode, showLabel]);

  useEffect(() => {
    if (menuCreation == false) setElementSelected(null);
    setElementsConnected(null);
  }, [menuCreation]);

  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current && mapRef.current.invalidateSize) {
        mapRef.current.invalidateSize();
      }
    }, 300);
  }, [collapse]);
  /* ---------- TEXTURAS ---------- */
  const texturesReady = useTextures(iconsElements);
  function isPointInBounds(point) {
    if (
      !point ||
      point.lat == null ||
      point.lat == "" ||
      point.lng == null ||
      point.lng == ""
    )
      return false;

    // Define os limites
    const southWest = L.latLng(-89.98155760646617, -180);
    const northEast = L.latLng(89.99346179538875, 180);
    const bounds = L.latLngBounds(southWest, northEast);

    // Cria um objeto LatLng com o ponto fornecido
    const latLngPoint = L.latLng(point.lat, point.lng);

    // Verifica se o ponto está dentro dos limites
    return bounds.contains(latLngPoint);
  }
  // -----------------------mapContext-----------------------

  function Events() {
    const map = useMap();

    useMapEvents({
      click(e) {
        if (rulerMode) {
          setRulerPoint((prev) => [...prev, e.latlng]);
        }
      },
      zoomanim(e) {
        setDisableLinesZoom(true);
        setZoomIcons(calculeZoom(map));
      },
      zoomend(e) {
        setDisableNodes(false);
        setDisableLinesZoom(false);
      },
      contextmenu(e) {
        onContextMenu(e);
      },
      move(e) {
        if (!map) return;
        updateUrl();
      },
    });

    return null;
  }

  const updateUrl = () => {
    if (moveTimeout.current) clearTimeout(moveTimeout.current);
    moveTimeout.current = setTimeout(() => {
      if (!mapRef.current) return;
      const map = mapRef.current;
      const center = map?.getBounds()?.getCenter();
      const zoom = map.getZoom();
      const url = new URL(window?.location?.href);
      url.searchParams.set("lat", center?.lat);
      url.searchParams.set("lng", center?.lng);
      url.searchParams.set("zoom", zoom);
      window.history.replaceState({}, "", url);
    }, 200);
  };

  const clearRuler = () => {
    setRulerPoint([]);
    setRulerMode(false);
  };

  const removeLast = () => {
    setRulerPoint((prev) => {
      if (prev.length === 0) return prev;
      return prev.slice(0, -2);
    });
  };

  const removeLastEl = () => {
    setRulerPoint((prev) => {
      if (prev.length === 0) return prev;
      return prev.slice(0, -1);
    });
  };

  const SetZoom = () => {
    const map = useMap();
    useEffect(() => {
      if (!map) return;
      setZoomIcons(calculeZoom(map));
    }, [map]);

    return null;
  };

  const SetMaxBounds = () => {
    const map = useMap(); // Acesse o objeto `map`
    useEffect(() => {
      if (!map) return;

      // Define os limites máximos do mapa
      const southWest = L.latLng(-89.98155760646617, -180);
      const northEast = L.latLng(89.99346179538875, 180);
      const bounds = L.latLngBounds(southWest, northEast);

      map.setMaxBounds(bounds);
      map.invalidateSize();
    }, [map]);

    return null;
  };

  const initialOptions = useMemo(() => {
    const urlValid =
      !Number.isNaN(latLngZoomFromUrl.lat) &&
      !Number.isNaN(latLngZoomFromUrl.lng) &&
      !Number.isNaN(latLngZoomFromUrl.zoom);

    if (urlValid) {
      return {
        center: [latLngZoomFromUrl.lat, latLngZoomFromUrl.lng],
        zoom: latLngZoomFromUrl.zoom,
      };
    }
    if (Array.isArray(boundsCoordinates)) {
      return {
        bounds: boundsCoordinates,
        maxZoom: 14,
      };
    }
    return {
      center: [-10, -48], // fallback
      zoom: 4,
    };
  }, [latLngZoomFromUrl, boundsCoordinates]);
  // ----------------------- fim mapContext-----------------------

  const calculeZoom = (map) => {
    const zoom = map.getZoom();
    const factor = scales[zoom];
    return factor;
  };
  const formatPoints = (element) => {
    let nodeStart = null,
      nodeEnd = null;

    if (element.referenceId == elementSelected?.id) nodeStart = elementSelected;
    else nodeStart = elements?.get(element.referenceId);

    if (element.destinationId == elementSelected?.id) nodeEnd = elementSelected;
    else nodeEnd = elements?.get(element.destinationId);

    let nodeStartPosition = {
      lat: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };
    let nodeEndPosition = {
      lat: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };

    let points = [
      nodeStartPosition,
      ...(element.positionHandlers ?? []).map((a) => ({
        lat: a.y,
        long: a.x,
        active: false,
      })),
      nodeEndPosition,
    ];

    return points;
  };
  function map_range(value, low1, high1, low2, high2) {
    return parseInt(low2 + ((high2 - low2) * (value - low1)) / (high1 - low1));
  }
  const simplifyRoute = (points, tolerance) => {
    const simplifiedPoints = points.map((point) => ({
      x: point.lat,
      y: point.lng,
    }));
    const simplified = simplify(simplifiedPoints, tolerance, true);
    return simplified.map((point) => L.latLng(point.x, point.y));
  };
  const cleanRouting = (enlace) => {
    setConnectionSelected((data) => {
      data.positionHandlers = [];
      return { ...data };
    });
  };
  async function autoRouting(enlace) {
    if (!mapRef.current) return;
    setLoadRouting(true);
    const precissao = {
      0: 0.01,
      1: 0.001,
      2: 0.0001,
      3: 0.00001,
    };

    let coordenadasEnd = elements?.get(enlace.destinationId)?.elementConfig
      ?.config?.coordenadas;
    coordenadasEnd = L.latLng(coordenadasEnd.lat, coordenadasEnd.long);

    let coordenadasStart = elements?.get(enlace.referenceId)?.elementConfig
      ?.config?.coordenadas;
    coordenadasStart = L.latLng(coordenadasStart.lat, coordenadasStart.long);

    setConnectionSelected((conn) => {
      if (conn?.positionHandlers) conn.positionHandlers = [];

      return { ...conn };
    });

    // Cria uma instância do L.Routing.control
    const router = new L.Routing.osrmv1();
    // Calcula a distância entre os pontos
    const distancia = L.latLng(coordenadasStart).distanceTo(coordenadasEnd);

    // Define o limiar de simplificação com base na distância
    let limiar = config.configuracoes?.geo?.limiarRouter;
    if (!limiar) limiar = 1;
    const distanciaKm = distancia / 1000;
    // Define o limiar de simplificação com base na distância
    if (distanciaKm > 1500) {
      limiar = Math.min(limiar, 0);
    } else if (distanciaKm > 400) {
      limiar = Math.min(limiar, 1);
    } else if (distanciaKm > 100) {
      limiar = Math.min(limiar, 2);
    }

    // Cria a rota
    router.route(
      [{ latLng: coordenadasStart }, { latLng: coordenadasEnd }],
      function (err, routes) {
        if (err) {
          console.error(err);
          return;
        }
        const points = routes[0].coordinates;
        const simplifiedPoints = simplifyRoute(points, precissao[limiar]);

        const pointsFormated = simplifiedPoints.map((point) => {
          return {
            x: point.lng,
            y: point.lat,
            active: false,
          };
        });
        setConnectionSelected((conn) => {
          conn.positionHandlers = pointsFormated;
          return { ...conn };
        });
        setLoadRouting(false);
      },
    );
  }
  //-------------- funcçoes de callbac dos alertas
  function newSelectionCallback(destination, tipo) {
    saveUpdateCallback();
    if (tipo == "elemento") {
      setConnectionSelected(null);
      onNodeClick(null, destination);
    } else if (tipo == "enlace") {
      setElementSelected(null);
      setConnectionSelected(connections?.get(destination.id) || null);
    }
  }
  function deleteCallback(id, tipo) {
    if (tipo == "enlace") handleDeleteLink(id);
    if (tipo == "elemento") handleDeleteElement(id);
  }
  const proceedUpdateMode = () => {
    saveUpdateCallback();
    setEditMode(!editMode);
    setFullScreem(false);
  };
  const saveUpdateCallback = () => {
    if (elementSelected && elementSelected?.id) {
      creationRef?.current?.update();
    } else {
      creationRef?.current?.create();
    }
    if (connectionSelected) {
      enlaceBarRef?.current?.update();
    }
  };
  function zoom(action) {
    if (!mapRef.current) return;
    const map = mapRef.current;
    let zoom = map.getZoom();
    // garante que o mapa não fique deslizando
    if (zoom > 17 && action > 0) return;
    if (zoom < 1 && action < 0) return;
    map.setZoom(zoom + action);
  }
  function focusZoom(id) {
    if (!id) return;
    let element = elements?.get(id);
    if (!element) return;
    let cood = element.elementConfig.config.coordenadas;
    focusZoomCoordenates(cood.lat, cood.long);
  }

  function focusZoomCoordenates(lat, lng) {
    const map = mapRef.current;
    setDisableNodes(true);
    setDisableLinesZoom(true);
    map.flyTo([lat, lng], 14);
  }
  const onNodeClick = (event, node) => {
    // Caixas de texto/HTML (tipo 3): só selecionáveis no modo de edição.
    // No modo de visualização não abrem a barra lateral de host.
    if (node?.tipo === 3 || node?.tipo === 4) {
      setConnectionSelected(null);
      if (editMode) {
        const key = node.id ?? node.tempId;
        const selectedKey = elementSelected?.id ?? elementSelected?.tempId;
        if (key === selectedKey) {
          setElementSelected(null);
          return;
        }
        setElementSelected(
          structuredClone(node.id ? (elements?.get(node.id) ?? node) : node),
        );
      }
      return;
    }
    setConnectionSelected(null);
    const selected = elements?.get(node?.id);
    if (selected?.id === elementSelected?.id) {
      setElementSelected(null);
      return;
    }
    setElementSelected(structuredClone(selected));
    if (!editMode) {
      const selected = elements?.get(node?.id);
      let idsElements = [selected?.id];
      let idsConnections = [];
      let elementsConnect = [];

      connectionsFromMap.forEach(({ referenceId, destinationId, id }) => {
        if (node?.id === destinationId || node?.id === referenceId) {
          const findElement = elements?.get(
            node?.id === destinationId ? referenceId : destinationId,
          );
          elementsConnect.push(findElement);
          idsElements.push(findElement?.id);
          idsConnections.push(id);
        }
      });
      setElementSelected(structuredClone(selected));
      setConnectionLocal(null);
      setElementsConnected(elementsConnect);
      setOpenRightBar(true);
    }
  };
  const onClickLine = useCallback(
    (id) => {
      let connection = connections?.get(id);
      if (editMode) {
        let bk = {
          ...connection,
          positionHandlers: structuredClone(connection.positionHandlers),
        };
        if (!checkChangesRef.current) {
          setElementSelected(null);
          setConnectionSelected(bk);
        } else {
          setOpenAlertModal({
            open: true,
            callback: newSelectionCallback,
            params: [bk, "enlace"],
            severity: "info",
            buttonText: "Salvar",
            buttonCancelText: "Voltar",
            text: "As alterações feitas não foram salvas. Deseja Salvá-las?",
          });
        }
        return;
      }

      let elemento = elements?.get(connection?.referenceId);
      setElementSelected(elemento);
      setConnectionLocal(connection);
      setOpenConnection(id);
    },
    [connections, editMode, checkChanges, elements],
  );

  const onPaneClick = (e) => {
    setContextMenu(null);
    if (!editMode) {
      if (connectionSelected) setConnectionSelected(null);
      if (connectionLocal) setConnectionLocal(null);
      if (elementsConnected) setElementsConnected(null);
      if (elementSelected) setElementSelected(null);
    }
  };
  const onNodeContextMenu = useCallback(
    (event, node) => {
      //event.preventDefault();
      if (editMode) {
        setContextMenu(
          contextMenu === null
            ? {
                id: node.id,
                top: event.containerPoint.y + 60,
                left: event.containerPoint.x + 310,
                node,
              }
            : null,
        );
      }
    },
    [setContextMenu, editMode],
  );
  const onContextMenu = useCallback(
    (event) => {
      //event.preventDefault();
      setContextMenuFlow(
        contextMenu === null
          ? {
              mouseX: event.containerPoint.x,
              mouseY: event.containerPoint.y,
            }
          : null,
      );
    },
    [setContextMenuFlow, editMode],
  );
  //-----funcoes para o socket
  async function handleCreateLink(connection) {
    try {
      //return;
      const response = await api.post("/easyMaps/link", connection);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o link",
          severity: "error",
        });
      } else {
        if (response.data?.link) {
          setConnections((prev) => {
            let next = new Map(prev);
            next.set(response.data.link.id, { ...response.data.link });
            return next;
          });
          setConnectionSelected(response.data?.link);
        }
      }
    } catch (error) {
      setSnackbar({
        children: `Error:${
          error?.message || "Erro na comunicação via socket"
        } `,
        severity: "error",
      });
    }
  }
  const handleUpdateLink = async (
    connection,
    edgeSelected,
    line,
    capacidade,
    animation,
    hostOriginId,
    flagLimiteAutomatico,
    flagCapacidadeAutomatica,
    limiteSuperiorPowerRX,
    limiteInferiorPowerRX,
    limiteSuperiorPowerTX,
    limiteInferiorPowerTX,
    sourceHandle,
    targetHandle,
    viewTypeLabel,
    interfaceDescription,
    interfaceName,
    edgeLabelSize,
  ) => {
    try {
      let updateConnection = connection;
      updateConnection.config = {
        type: line ?? "reta",
        sourceHandle: connection?.config?.sourceHandle ?? "right",
        targetHandle: connection?.config?.targetHandle ?? "left",
        capacidade,
        animation: animation ?? "desativada",
        hostOriginId,
        flagLimiteAutomatico,
        flagCapacidadeAutomatica,
        limiteSuperiorPowerRX,
        limiteInferiorPowerRX,
        limiteSuperiorPowerTX,
        limiteInferiorPowerTX,
        interfaceDescription,
        interfaceName,
      };
      const response = await api.put("/easyMaps/link", updateConnection);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o link",
          severity: "error",
        });
      } else {
        if (response.data) {
          let updateConnection = response.data.link;
          setConnections((prev) => {
            let next = new Map(prev);
            next.set(updateConnection.id, { ...updateConnection });
            return next;
          });
          setConnectionSelected(null);
          setCheckChanges(false);
          updateDataElementSocket();
          setSnackbar({
            children: "A conexão foi atualizada com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      setSnackbar({
        children: `Error:${
          error?.message || "Erro na comunicação via socket"
        } `,
        severity: "error",
      });
    }
  };
  // remover enlace
  const handleDeleteLink = async (id) => {
    try {
      const response = await api.delete("/easyMaps/link", { data: { id } });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        setElementSelected(null);
        //setRequestSend(false);
        if (response.data) {
          let updateConnection = response.data.link;
          setConnections((prev) => {
            let next = new Map(prev);
            next.delete(updateConnection.id);
            return next;
          });
          setConnectionSelected(null);
        }
      }
    } catch (error) {
      setSnackbar({
        children: `Error:${
          error?.message || "Erro na comunicação via socket"
        } `,
        severity: "error",
      });
    }
  };
  //para caso de duplicar elemento
  const handleDuplicateElement = async (id) => {
    try {
      let data = structuredClone(elements.get(id));
      if (!data) return;
      delete data.id;
      data.titulo = data?.titulo + " (cópia)";
      data.configuracao = {
        ...data.elementConfig?.config,
        coordenadas: {
          long: parseFloat(data.elementConfig.config?.coordenadas?.long) + 0.5,
          lat: parseFloat(data.elementConfig.config?.coordenadas?.lat) + 0.5,
        },
      };

      const response = await api.post("/easyMaps/element", data);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        if (response.data) {
          setElements((elements) => {
            const els = new Map(elements);
            els.set(response.data?.element.id, {
              ...response.data?.element,
            });
            return els;
          });
          setElementSelected(structuredClone(response.data?.element));
          updateDataElementSocket();
        }
      }
    } catch (error) {
      setSnackbar({
        children: `Error:${
          error?.message || "Erro na comunicação via socket"
        } `,
        severity: "error",
      });
    }
  };
  const handleDeleteElement = async (id) => {
    try {
      let logs = JSON.parse(localStorage.getItem("logs"));

      const response = await api.delete("/easyMaps/element", {
        data: { id, logsLoginClienteId: logs.id },
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        if (response.data) {
          setConnections((prev) => {
            const next = new Map(prev);
            const toDelete = [];

            // 1️⃣ Coleta os IDs das conexões que devem ser removidas
            next.forEach((con) => {
              if (
                con.referenceId === response.data?.element?.id ||
                con.destinationId === response.data?.element?.id
              ) {
                toDelete.push(con.id);
              }
            });

            // 2️⃣ Remove os elementos depois da iteração
            toDelete.forEach((id) => next.delete(id));

            return next;
          });
          setElements((prev) => {
            const next = new Map(prev);
            next.delete(response.data?.element?.id);
            return next;
          });
          setElementSelected(null);
          setConnectionSelected(null);
          setSnackbar({
            children: "Elemento deletado com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      setSnackbar({
        children: `Error:${
          error?.message || "Erro na comunicação via socket"
        } `,
        severity: "error",
      });
    }
  };
  const handleUpdatePositionElement = async (element, position) => {
    setCheckChanges(true);

    setElementSelected((data) => ({
      ...data,
      elementConfig: {
        ...data.elementConfig,
        config: {
          ...data.elementConfig?.config,
          coordenadas: {
            lat: position?.lat,
            long: position?.lng,
          },
        },
      },
    }));
  };

  const handleUpdatePolygonPoints = async (element, points) => {
    setCheckChanges(true);

    const center =
      points?.length > 0
        ? L.latLngBounds(points.map((p) => [p.lat, p.long])).getCenter()
        : null;

    setElementSelected((data) => ({
      ...data,
      elementConfig: {
        ...data.elementConfig,
        config: {
          ...data.elementConfig?.config,
          polygon: {
            ...data.elementConfig?.config?.polygon,
            points,
          },
          ...(center
            ? { coordenadas: { lat: center.lat, long: center.lng } }
            : {}),
        },
      },
    }));
  };

  const changeEdge = (edgeId, updateData) => {
    setConnections((prev) => {
      const next = new Map(prev);

      if (next.has(edgeId)) {
        const con = next.get(edgeId);
        next.set(edgeId, {
          ...con,
          config: {
            ...con.config,
            ...updateData,
          },
        });
      }

      return next;
    });
  };
  const updateEdge = useCallback((index, edgeUpdate) => {
    setPointsClone((prev) => {
      let newArray = [...prev];
      newArray[index + 1] = {
        long: edgeUpdate.newPosition.lng,
        lat: edgeUpdate.newPosition.lat,
        active: true,
      };

      return newArray;
    });
    setCheckChanges(true);
  }, []);
  const updateEdgeEnd = (index, edgeUpdate) => {
    setConnectionSelected((data) => {
      data.positionHandlers[index] = edgeUpdate;
      return { ...data };
    });
    setCheckChanges(true);
  };
  const removeEdge = (index) => {
    setConnectionSelected((data) => {
      data.positionHandlers.splice(index, 1);
      return { ...data };
    });
    setCheckChanges(true);
  };
  const addMapInMaps = (map) => {
    setMapas([...mapas, { nome: map?.titulo, tipo: map?.tipo, id: map?.id }]);
  };
  // pega o gesto de pinça no mobile, pois esse evento não esta disponivel no wrapper do leaflet-react
  function TouchHandler() {
    const map = useMap();

    useEffect(() => {
      const handleTouchMove = (e) => {
        if (e.touches?.length === 2) {
          setDisableLinesZoom(true);
        }
      };

      const handleTouchEnd = () => {
        setDisableLinesZoom(false);
      };

      // Eventos nativos do Leaflet
      map.getContainer().addEventListener("touchmove", handleTouchMove);
      map.getContainer().addEventListener("touchend", handleTouchEnd);

      return () => {
        map.getContainer().removeEventListener("touchmove", handleTouchMove);
        map.getContainer().removeEventListener("touchend", handleTouchEnd);
      };
    }, [map, setDisableLinesZoom]);

    return null;
  }

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1202 }}>
        <TitleBar title={title} id={mapId} />
      </Box>

      <Box sx={styles.body}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <ToolBarMaps
            proceedUpdateMode={proceedUpdateMode}
            editMode={editMode}
            setEditMode={setEditMode}
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            lockMode={lockMode}
            setLockMode={setLockMode}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            setOpenAlertModal={setOpenAlertModal}
            checkChanges={checkChanges}
            setShowRuler={setRulerMode}
            setRulerPoint={setRulerPoint}
            showRuler={rulerMode}
            tipo={0}
            hideArea={hideArea}
            setHideArea={setHideArea}
          >
            <ToolBarMaps.InputZoomGeo zoom={zoom} />
          </ToolBarMaps>

          <FilterGeneric
            items={hostGroups}
            selectedItems={hostGroupsFilter}
            setSelectedItems={setHostGroupsFilter}
            visibleItems={visibleHostGroups}
            label="Grupos"
            filters={filtersOptions}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />

          <LayerBar
            elementSelected={elementSelected}
            mapId={mapId}
            editMode={editMode}
          />
          {!editMode && (
            <DescriptionBar
              elementSelected={elementSelected}
              key={"descrptionbar"}
              variant="default"
              layer={configLayer?.[mapId] || "trafego"}
              rangeCounts={rangeCounts}
            />
          )}
          {startMapRef.current && (
            <MapContainer
              {...initialOptions}
              maxBoundsViscosity={1}
              worldCopyJump={true}
              key={fullScreem ? `mapaFull` : `mapaSingle`}
              fullscreenControl={false}
              ref={mapRef}
              id="map"
              inertia={true}
              boxZoom={true}
              minZoom={3}
              maxZoom={19}
              whenReady={() => updateUrl()}
              //preferCanvas={true} // se true a animção da linha não funfa, exceto se na linha especificar o svg como render
              fadeAnimation={false}
              zoomControl={false}
              easeLinearity={0.6}
              doubleClickZoom={false}
              enableHighAccuracy={true}
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 0,
              }}
            >
              <TileLayer
                url={
                  theme.palette.mode == "dark"
                    ? config?.mapaTile?.dark ||
                      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    : config?.mapaTile?.light ||
                      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                }
                //url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                //url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                //url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                //satelite
                //url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                maxZoom={19}
                attribution="&copy; OpenStreetMap contributors"
              />
              <Events />
              <SetMaxBounds />
              <TouchHandler />
              {/* <SetInitialScene /> */}

              <SetZoom />
              {rulerMode && (
                <RulerComponent
                  rulerPoints={rulerPoint}
                  removeLast={removeLast}
                  onClearRuler={clearRuler}
                />
              )}

              {/* renderiza as linha durante a edição, após a seleção*/}
              {editMode && connectionSelected && (
                <Fragment key={pointsClone.length}>
                  {!disableLinesZoom &&
                    pointsClone?.map(
                      (point, index) =>
                        index != 0 &&
                        index != pointsClone.length - 1 && (
                          <PointIcon
                            point={point}
                            index={index - 1}
                            updateEdge={updateEdge}
                            updateEdgeEnd={updateEdgeEnd}
                            removeEdge={removeEdge}
                            key={index + "pointsEdited"}
                          />
                        ),
                    )}
                  {!disableLinesZoom &&
                    pointsClone
                      .slice(0, pointsClone.length - 1)
                      .map((point, index) => {
                        let mode;
                        if (pointsClone.length === 2) mode = "both";
                        else if (index === 0) mode = "start";
                        else if (index === pointsClone.length - 2) mode = "end";

                        return (
                          <PolylineSimple
                            key={"lineEdit" + index + pointsClone[index].lat}
                            positions={[
                              [pointsClone[index].lat, pointsClone[index].long],
                              [
                                pointsClone[index + 1].lat,
                                pointsClone[index + 1].long,
                              ],
                            ]}
                            dbClick={(e) => {
                              let newPosition = {
                                y: e.latlng.lat,
                                x: e.latlng.lng,
                              };
                              setConnectionSelected((data) => {
                                data?.positionHandlers?.splice(
                                  index,
                                  0,
                                  newPosition,
                                );
                                return { ...data };
                              });
                            }}
                            shrinkEdges={mode}
                            radiusNodePixi={radiusNodePixi}
                            rulerMode={rulerMode}
                          />
                        );
                      })}
                </Fragment>
              )}

              {texturesReady && (
                <PixiOverlay
                  key={"pixiGeo"}
                  markers={
                    insideElementIds
                      ? finalData.markers.filter((m) =>
                          insideElementIds.has(m.id),
                        )
                      : finalData.markers
                  }
                  elementSelected={elementSelected}
                  editable={editMode}
                  onClick={onNodeClick}
                  onClickLine={onClickLine}
                  onBackgroundClick={onPaneClick}
                  handleUpdatePositionElement={handleUpdatePositionElement}
                  iconsElements={iconsElements}
                  disable={disableNodes}
                  showLabel={showLabel}
                  onRadiusChange={(r) => {
                    setRadiusNodePixi(r);
                  }}
                  rulerMode={rulerMode}
                  connections={finalData?.enlaces.filter(
                    (conn) =>
                      conn.id !== connectionSelected?.id &&
                      (!insideElementIds ||
                        (insideElementIds.has(conn.referenceId) &&
                          insideElementIds.has(conn.destinationId))),
                  )}
                  zoom={zoomIcons}
                  editMode={editMode}
                  configurationMap={configurationMap}
                  connectionsDataMap={connectionsDataMap}
                  configElementDataMap={configElementDataMap}
                  disableLinesZoom={disableLinesZoom}
                  checkChanges={checkChanges}
                />
              )}

              {/* Caixas de texto/HTML (tipo 3): renderizadas via L.divIcon,
                  pois o overlay Pixi só desenha sprites de ícone. As não
                  selecionadas vêm do estado do mapa; a selecionada/em criação
                  vem do elementSelected p/ refletir arraste ao vivo. */}
              {elementsFromMap
                ?.filter(
                  (el) =>
                    el.tipo === 3 &&
                    (!insideElementIds ||
                      insideElementIds.has(el.id ?? el.tempId)) &&
                    (el.id ?? el.tempId) !==
                      (elementSelected?.id ?? elementSelected?.tempId),
                )
                .map((el) => (
                  <TextBoxLayer
                    key={el.id ?? el.tempId}
                    element={el}
                    editable={editMode}
                    selected={false}
                    onNodeClick={onNodeClick}
                    handleUpdatePositionElement={handleUpdatePositionElement}
                  />
                ))}
              {editMode && elementSelected?.tipo === 3 && (
                <TextBoxLayer
                  key={elementSelected.id ?? elementSelected.tempId}
                  element={elementSelected}
                  editable
                  selected
                  onNodeClick={onNodeClick}
                  handleUpdatePositionElement={handleUpdatePositionElement}
                />
              )}

              {/* Áreas/polígonos (tipo 4): renderizadas via leaflet-draw */}
              {elementsFromMap
                ?.filter(
                  (el) =>
                    el.tipo === 4 &&
                    !hideArea &&
                    (el.id ?? el.tempId) !==
                      (elementSelected?.id ?? elementSelected?.tempId),
                )
                .map((el) => (
                  <PolygonLayer
                    key={el.id ?? el.tempId}
                    element={el}
                    editable={editMode}
                    selected={false}
                    onNodeClick={onNodeClick}
                    handleUpdatePolygonPoints={handleUpdatePolygonPoints}
                  />
                ))}
              {editMode && elementSelected?.tipo === 4 && !hideArea && (
                <PolygonLayer
                  key={elementSelected.id ?? elementSelected.tempId}
                  element={elementSelected}
                  editable
                  selected
                  onNodeClick={onNodeClick}
                  handleUpdatePolygonPoints={handleUpdatePolygonPoints}
                />
              )}
            </MapContainer>
          )}

          {editMode && (
            <MenuMaps
              iconsElement={iconsElements?.filter((icon) =>
                icon?.nome?.startsWith("_"),
              )}
              setConnectionSelected={setConnectionSelected}
              setElementSelected={setElementSelected}
              checkChanges={checkChanges}
              setOpenAlertModal={setOpenAlertModal}
              saveUpdateCallback={saveUpdateCallback}
              isGeolocalizado={true}
              openEnlaceBar={openEnlaceBar}
              setOpenEnlaceBar={setOpenEnlaceBar}
            />
          )}

          <RightBarEasyMaps
            mapId={mapId}
            setFocusNodeId={focusZoom}
            open={openRightBar}
            setOpen={setOpenRightBar}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={!editMode && elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/${
              elementSelected?.mapRef?.tipo === 0
                ? "geo"
                : elementSelected?.mapRef?.tipo === 4
                  ? "ping"
                  : "top"
            }/${elementSelected?.mapRefId ?? ""}`}
            setOpenHistoryModal={setOpenHistoryModal}
            connectionSelectedLocal={connectionLocal}
            setConnectionLocal={setConnectionLocal}
            setHostParamModal={setHostParamModal}
          />

          <CreationSliderBarEasyMaps
            fullScreem={fullScreem}
            isPointInBounds={isPointInBounds}
            ref={creationRef}
            setOpenAlertModal={setOpenAlertModal}
            onImportComplete={onImportComplete}
            handleUpdatePositionElement={handleUpdatePositionElement}
            updateDataElementSocket={updateDataElementSocket}
            focusZoomCoordenates={focusZoomCoordenates}
            iconsElement={iconsElements}
            setIconsElement={setIconsElement}
            socket={socketCliente}
            setElementSelected={setElementSelected}
            element={editMode ? elementSelected : null}
            elements={elementsFromMap}
            produtos={produtos}
            api={api}
            maps={mapas}
            addMapInMaps={addMapInMaps}
            checkChanges={checkChanges}
            setCheckChanges={setCheckChanges}
            centerLeaflatMap={mapRef?.current?.getCenter()}
            deleteElementSocket={(id) =>
              setOpenAlertModal({
                open: true,
                callback: deleteCallback,
                params: [id, "elemento"],
                severity: "error",
                tipo: "element",
              })
            }
            loadRouting={loadRouting}
            setLoadRouting={setLoadRouting}
            autoRouting={autoRouting}
            cleanRouting={cleanRouting}
            typeElement={typeElements[elementSelected?.tipo]}
            openEnlaceBar={openEnlaceBar}
            setOpenEnlaceBar={setOpenEnlaceBar}
            setOpenMassEditPolygon={setOpenMassEditPolygon}
          />
          <EnlaceSideBarEasyMaps
            ref={enlaceBarRef}
            setOpenAlertModal={setOpenAlertModal}
            loadRouting={loadRouting}
            setLoadRouting={setLoadRouting}
            autoRouting={autoRouting}
            cleanRouting={cleanRouting}
            connection={editMode ? connectionSelected : null}
            setConnection={setConnectionSelected}
            api={api}
            socket={socketCliente}
            produtos={produtos}
            iconsElement={iconsElements}
            setIconsElement={setIconsElement}
            saveConnection={handleUpdateLink}
            changeEdge={changeEdge}
            fullScreem={fullScreem}
            handleDelete={(id) =>
              setOpenAlertModal({
                open: true,
                callback: deleteCallback,
                params: [id, "enlace"],
                severity: "error",
              })
            }
            elementSelected={elementSelected}
          />
        </Box>
        {contextMenu && editMode && (
          <ElementMenu
            open={contextMenu !== null}
            onClose={onPaneClick}
            handleDelete={(id) => {
              setOpenAlertModal({
                open: true,
                callback: deleteCallback,
                params: [id, "elemento"],
                severity: "error",
              });
            }}
            handleCreate={handleDuplicateElement}
            {...contextMenu}
          />
        )}
        {!rulerMode && (
          <ContextMenu
            contextMenu={contextMenuFlow}
            setContextMenu={setContextMenuFlow}
            editMode={editMode}
            setEditMode={setEditMode}
          />
        )}
        <ModalHistoryItem
          openHistoryModal={openHistoryModal}
          setOpenHistoryModal={setOpenHistoryModal}
          elementSelected={elementSelected}
          enlaceSelected={connectionLocal}
          iconsElements={iconsElements}
          host={hostParamModal}
        />
        <ModalEditMassPolygon
          open={openMassEditPolygon}
          onClose={() => setOpenMassEditPolygon(false)}
          mapId={mapId}
          elements={polygons}
          setSnackbar={setSnackbar}
          onSaveComplete={handleMassPolygonComplete}
        />
        <AlertModal
          openModal={openAlertModal?.open ?? false}
          setOpenModal={(data) => setOpenAlertModal({ open: data })}
          buttonText={openAlertModal?.buttonText}
          buttonCancelText={openAlertModal?.buttonCancelText}
          confirmar={false}
          handleButton={() => {
            setCheckChanges(false);
            setOpenAlertModal({ open: false });
            if (openAlertModal.callback) {
              openAlertModal.callback(...(openAlertModal?.params || []));
              return;
            }
            setElementSelected(null);
            setConnectionSelected(null);
          }}
          severity={openAlertModal?.severity}
          singleButton={false}
          textContent={openAlertModal?.text}
        />
      </Box>
    </>
  );
});

export default LeafletMapa;
